import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderSKzSInfoGql } from '../../workOrderQueries';

const requestId = 'uerWorkOrderSKzSInfo';

export const useUerWorkOrderSKzSInfo = (workOrderId: number) => {
    const dispatch = useDispatch();

    const [uerWorkOrderSKzSInfoReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ workOrderId }), [workOrderId]);

    const [uerWorkOrderSKzSInfoData, uerWorkOrderSKzSInfoStatus, , uerWorkOrderSKzSInfoMakeRequest] = useRequest({
        requestId,
        query: uerWorkOrderSKzSInfoGql,
        variables,
        withEffect: false,
    });

    const uerWorkOrderSKzSInfoRefresh = useCallback(() => {
        dispatch(uerWorkOrderSKzSInfoMakeRequest(variables));
    }, [dispatch, uerWorkOrderSKzSInfoMakeRequest, variables]);

    useEffect(() => {
        uerWorkOrderSKzSInfoReset(undefined);
    }, [uerWorkOrderSKzSInfoReset]);

    return {
        uerWorkOrderSKzSInfoData,
        uerWorkOrderSKzSInfoStatus,
        uerWorkOrderSKzSInfoRefresh,
    };
};
